import React, { useState, useEffect } from 'react';
import '../App.css';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import jsPDF from 'jspdf';

const Survey = () => {
    const [socialIssue, setSocialIssue] = useState('');
    const [geography, setGeography] = useState('');
    const [org, setOrg] = useState('');
    const [outcome, setOutcome] = useState('');
    const [target_group, setTargetGroup] = useState('');
    const [openness_ratio, setOpennessRatio] = useState('');

    const [loading, setLoading] = useState(false);
    const [answer, setAnswer] = useState('');
    const [sessionId, setSessionId] = useState(null);
    const [user, setUser] = useState(null);
    const [error, setError] = useState(null);
    const [feedbackGiven, setFeedbackGiven] = useState(false);

    const showdown = require('showdown');
    const converter = new showdown.Converter();

    const handleFeedback = async (feedbackType, interactionId) => {
        try {
          const response = await fetch('https://ax9p2w4vm3.execute-api.eu-north-1.amazonaws.com/dev2/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 
                "InteractionId": interactionId, 
                "Feedback": feedbackType 
            }), // Send interaction ID and feedback text
          });
          setFeedbackGiven(true); 
        } catch (error) {
          console.error('Error submitting feedback:', error);
        }
      };
    // create a session id for the conversation
    useEffect(() => {
        const sessionId = Math.random().toString(36).substring(7);
        setSessionId(sessionId);
    }, []);
    
    useEffect(() => {
      fetchUser();
    }, []);

    async function fetchUser() {
        try {
          const currentUser = await getCurrentUser();
          const userAttributes = await fetchUserAttributes();
          setUser({ ...currentUser, ...userAttributes });
        } catch (error) {
          console.error('Error fetching user', error);
        }
    }


    const callAPI  = async (e) => {
        e.preventDefault();
        //MAKE THE LOADING TRUE ONLY 1 MINUTE

        setLoading(true); // Show loader for 1 minute
        //setLoading(true, ); // Show loader
        setAnswer(null); // Reset answer state
        setError(null);
        setFeedbackGiven(false);
        
        
        try {
            const response = await fetch('https://jnhyo3iqg4.execute-api.eu-north-1.amazonaws.com/survey', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ 
                    "social_issue": socialIssue,
                    "geography": geography,
                    "organisation": org,
                    "outcome": outcome,
                    "target_group": target_group,
                    "openness_ratio": openness_ratio,
                    "session_id": sessionId,
                    "user_id": user.username 
                })
            });
            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);

            }
            const data = await response.json();
            //const data = JSON.parse(result.body);
            console.log(data);
            console.log(data.answer);
            if (data.answer) {
                setAnswer({
                    answer: data.answer,
                    interaction_id: data.interactionId
                });
            } else {
                setAnswer('Answer field is missing in the response.');
            }
            } catch (error) {
                setAnswer(error.message);
                console.error('Fetch error:', error);
            } finally {
                setLoading(false);
            }
    };
    function copyToClipboard() {
        const answerDiv = document.getElementById('answerDiv');
        const text = answerDiv.innerText; // Extract only the text content
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        
    }

    const downloadAsPDF = () => {
        const doc = new jsPDF('p', 'mm', 'a4');
        const pageHeight = doc.internal.pageSize.height;
        const margin = 20;
        const lineHeight = 7; // Line height for text
        const titleFontSize = 16; // Font size for titles
        const regularFontSize = 12; // Font size for regular text
        const titleSpacing = 10; // Space before and after titles
        const sectionSpacing = 5; // Space between sections
        doc.setFontSize(regularFontSize);
        let y = margin;
    
        const addTextToPDF = (text, isTitle = false) => {
            if (isTitle) {
                doc.setFontSize(titleFontSize); // Larger font for titles
                y += titleSpacing; // Space before title
            } else {
                doc.setFontSize(regularFontSize); // Regular font size
            }
    
            if (!text || typeof text !== 'string') return; // Skip if text is invalid
    
            const lines = doc.splitTextToSize(text, doc.internal.pageSize.width - 2 * margin);
            lines.forEach((line) => {
                if (y + lineHeight > pageHeight - margin) {
                    doc.addPage();
                    y = margin;
                }
                doc.text(line, margin, y, { maxWidth: doc.internal.pageSize.width - 2 * margin });
                y += lineHeight;
            });
    
            if (isTitle) {
                // y += titleSpacing; // Space after title
            } else {
                y += sectionSpacing; // Space after regular text
            }
        };
    
        const addTextWithColor = (text, color) => {
            doc.setTextColor(color[0], color[1], color[2]); // Set RGB color
            addTextToPDF(text, true); // Use `true` to apply title formatting
            doc.setTextColor(0, 0, 0); // Reset to black after adding colored text
        };
    
        const addListToPDF = (items) => {
            items.forEach((item, index) => {
                if (item && item.question) {
                    const typeLabel = item.type === 'OPEN' ? 'Open Question:' : 'Closed Question:';
                    const listItem = `${index + 1}. ${typeLabel} ${item.question}`;
                    addTextToPDF(listItem);
                }
            });
        };
    
        // Check if answer.answer is valid
        if (answer && answer.answer) {
            const survey = answer.answer;
    
            // Add the survey title
            addTextWithColor(survey.survey_name, [255, 20, 147]);
    
            // Add the introduction
            addTextToPDF(survey.intro);
    
            // Add sections with questions
            if (survey.background_questions && survey.background_questions.length > 0) {
                addTextWithColor("Background Questions:", [255, 20, 147]);
                addListToPDF(survey.background_questions);
            }
    
            if (survey.outcome_questions && survey.outcome_questions.length > 0) {
                addTextWithColor("Outcome Questions:", [255, 20, 147]);
                addListToPDF(survey.outcome_questions);
            }
    
            if (survey.satisfaction_questions && survey.satisfaction_questions.length > 0) {
                addTextWithColor("Satisfaction Questions:", [255, 20, 147]);
                addListToPDF(survey.satisfaction_questions);
            }
    
            // Add exit text
            if (survey.exit) {
                addTextWithColor("Exit:", [255, 20, 147]);
                addTextToPDF(survey.exit);
            }
        } else {
            console.error("The answer or its properties are not defined.");
        }
    
        doc.save('survey.pdf');
    };

    return (
        <div>
            <div className="title-section">
                <h2 className="title-text">Survey Generator</h2>
                <img src="https://rfc-info.s3.eu-north-1.amazonaws.com/Survey Generator.png" alt="RFC Problem Analysis" className="title-icon2" />
            </div>
                <h4>Receive help on how to collect your own data via a survey!</h4>
                <form onSubmit={callAPI}>
                <div className="input-grid">
                    <div className="input-container">
                        <label>Enter the social issue:</label>
                        <input
                            type="text"
                            id="socialIssue"
                            placeholder="Enter social issue..."
                            required
                            value={socialIssue}
                            onChange={(e) => setSocialIssue(e.target.value)}
                            />
                    </div>
                    <div className="input-container">
                        <label htmlFor="geography">Enter the geography:</label>
                        <input
                            type="text"
                            id="geography"
                            placeholder="Enter geography..."
                            required
                            value={geography}
                            onChange={(e) => setGeography(e.target.value)}
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="org">Enter the organisation:</label>
                        <input
                            type="text"
                            id="org"
                            placeholder="Enter organisation..."
                            required
                            value={org}
                            onChange={(e) => setOrg(e.target.value)}
                        />
                        <p className="placeholder-text-interview"> Enter the full name of your organization as it is officially registered. This helps identify the organization responsible for the survey or initiative. E.g. Reach For Change.</p>
                    </div>
                    <div className="input-container">
                        <label htmlFor="outcome">Enter the expected outcome:</label>
                        <input
                            type="text"
                            id="outcome"
                            placeholder="Enter outcome..."
                            required
                            value={outcome}
                            onChange={(e) => setOutcome(e.target.value)}
                        />
                        <p className="placeholder-text-interview"> Describe the main result or effect you aim to achieve through your project or initiative. This should be a clear, measurable goal or result. E.g. Improve literacy rates among children in rural areas by 20%.</p>
                    </div>
                    <div className="input-container">
                        <label htmlFor="target_group">Enter the target group:</label>
                        <input
                            type="target_group"
                            id="duration"
                            placeholder="Enter target group..."
                            required
                            value={target_group}
                            onChange={(e) => setTargetGroup(e.target.value)}
                        />
                        <p className="placeholder-text-interview">Specify the demographic or group of individuals your project or initiative is designed to benefit. This could include age groups, gender, socio-economic status, or other characteristics. E.g. Children aged 6-12 from low-income families.</p>
                    </div>
                    <div className="input-container">
                        <label htmlFor="openness_ratio">Choose the opennes of the question:</label>
                        <select
                            id="openness_ratio"
                            required
                            value={openness_ratio}
                            onChange={(e) => setOpennessRatio(parseFloat(e.target.value))}
                        >
                            <option value="">Select Between [0, 0.5, 1]</option>
                            <option value="0">0</option>
                            <option value="0.5">0.5</option>
                            <option value="1">1</option>
                        </select>
                        <p className="placeholder-text-interview">
                        Enter a value between 0 and 1 to indicate the desired balance between open-ended and closed-ended questions in your survey.<br /><br />
                        • A value of 0 means that all questions will be closed-ended (specific, multiple-choice, or yes/no questions).<br /><br />
                        • A value of 1 means that all questions will be open-ended (questions that require detailed responses).<br /><br />
                        • Values in between will result in a mix of both types of questions, proportionally determined by the ratio.
                    </p>
                    </div>
                </div>
                <p className="placeholder-text-ai">Note: AI-generated content may contain errors. Please verify the information.</p>
                    <div className="input-container">
                        <button type="submit">Generate Survey</button>
                    </div>
                </form>
           
                {loading && (
                    <div className="loader">
                        <span className="loader-text">Loading...</span>
                        <span className="load"></span>
                    </div>
                )}
                <div id="answerDiv" aria-live="polite">
                {answer && typeof answer === 'object' ? (
                    <div>
                        <p><strong>Answer:</strong></p>
                        {answer && (
                        <div>
                            <h3>{answer.answer.survey_name}</h3>
                            <p>{answer.answer.intro}</p>

                            {answer.answer.background_questions && answer.answer.background_questions.length > 0 && (
                                <div>
                                    <h5>Background Questions:</h5>
                                    <ul>
                                        {answer.answer.background_questions.map((question, index) => (
                                            <li key={index}>
                                                {question.type === "OPEN" ? (
                                                    <div>
                                                        <strong>Open Question:</strong> {question.question}
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <strong>Closed Question:</strong> {question.question}
                                                    </div>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {answer.answer.outcome_questions && answer.answer.outcome_questions.length > 0 && (
                                <div>
                                    <h5>Outcome Questions:</h5>
                                    <ul>
                                        {answer.answer.outcome_questions.map((question, index) => (
                                            <li key={index}>
                                                {question.type === "OPEN" ? (
                                                    <div>
                                                        <strong>Open Question:</strong> {question.question}
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <strong>Closed Question:</strong> {question.question}
                                                    </div>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {answer.answer.satisfaction_questions && answer.answer.satisfaction_questions.length > 0 && (
                                <div>
                                    <h5>Satisfaction Questions:</h5>
                                    <ul>
                                        {answer.answer.satisfaction_questions.map((question, index) => (
                                            <li key={index}>
                                                {question.type === "OPEN" ? (
                                                    <div>
                                                        <strong>Open Question:</strong> {question.question}
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <strong>Closed Question:</strong> {question.question}
                                                    </div>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <br/>
                            <p>{answer.answer.exit}</p>
                        </div>
                        )}
                        <br/>
                        <p className="placeholder-text-ai">Note: AI-generated content may contain errors. Please verify the information.</p>
                        <div class="button-row-container">
                        <div onClick={copyToClipboard} class="Btn" role="button" tabindex="0">
                            <span class="text">Copy</span>
                            <span class="svgIcon">
                                <svg fill="white" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"></path>
                                </svg>
                            </span>
                        </div>
                        <button onClick={downloadAsPDF} className="pdf-button">Download as PDF</button>
                        </div>
                    {!feedbackGiven ? (
                        <div className="input-row">
                            <div className="checkboxButton" onClick={() => handleFeedback('Like', answer.interaction_id)}>
                                <label className="feedback">
                                    <input type="checkbox" />
                                    <svg
                                        id="Glyph"
                                        version="1.1"
                                        viewBox="0 0 32 32"
                                        xmlSpace="preserve"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                        <path
                                            d="M29.845,17.099l-2.489,8.725C26.989,27.105,25.804,28,24.473,28H11c-0.553,0-1-0.448-1-1V13  c0-0.215,0.069-0.425,0.198-0.597l5.392-7.24C16.188,4.414,17.05,4,17.974,4C19.643,4,21,5.357,21,7.026V12h5.002  c1.265,0,2.427,0.579,3.188,1.589C29.954,14.601,30.192,15.88,29.845,17.099z"
                                            id="XMLID_254_"
                                        ></path>
                                        <path
                                            d="M7,12H3c-0.553,0-1,0.448-1,1v14c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1V13C8,12.448,7.553,12,7,12z   M5,25.5c-0.828,0-1.5-0.672-1.5-1.5c0-0.828,0.672-1.5,1.5-1.5c0.828,0,1.5,0.672,1.5,1.5C6.5,24.828,5.828,25.5,5,25.5z"
                                            id="XMLID_256_"
                                        ></path>
                                    </svg>
                                </label>
                            </div>
                            <div className="checkboxButton" onClick={() => handleFeedback('Dislike', answer.interaction_id)}>
                                <label className="feedback">
                                    <input type="checkbox" />
                                    <svg
                                        id="Glyph"
                                        version="1.1"
                                        viewBox="0 0 32 32"
                                        xmlSpace="preserve"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                        <path d="M2.156,14.901l2.489-8.725C5.012,4.895,6.197,4,7.528,4h13.473C21.554,4,22,4.448,22,5v14  c0,0.215-0.068,0.425-0.197,0.597l-5.392,7.24C15.813,27.586,14.951,28,14.027,28c-1.669,0-3.026-1.357-3.026-3.026V20H5.999  c-1.265,0-2.427-0.579-3.188-1.589C2.047,17.399,1.809,16.12,2.156,14.901z"
                                            id="XMLID_259_"></path>
                                        <path d="M25.001,20h4C29.554,20,30,19.552,30,19V5c0-0.552-0.446-1-0.999-1h-4c-0.553,0-1,0.448-1,1v14  C24.001,19.552,24.448,20,25.001,20z M27.001,6.5c0.828,0,1.5,0.672,1.5,1.5c0,0.828-0.672,1.5-1.5,1.5c-0.828,0-1.5-0.672-1.5  C25.501,7.172,26.173,6.5,27.001,6.5z"
                                            id="XMLID_260_"></path>
                                    </svg>
                                </label>
                            </div>
                        </div>
                    ) : (
                        <p className="feedback-thanks">Thank you for your feedback! 😄</p>
                    )}
                </div>
            ) : (
        <p className="error">{answer}</p>
            )}
        </div>
            </div>
        );
    };

export default Survey;